/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
import { ofType } from "redux-observable"
import { concat, from, of, zip } from "rxjs"
import { catchError, concatMap, endWith, flatMap, map, mergeAll, mergeMap, startWith, switchMap, take } from "rxjs/operators"

import CONSTANTS from "../../assets/js/Constants"

// Todo Calendar reminder config transportation
// Api lấy danh sách cấu hình  bảo dưỡng
const getListForCalendarMaintananceConfig = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.CALENDAR_MAINTANANCE_CONFIG_TRANSPORTATION.GET_LIST),
      mergeMap((action) => {
         const api = async () => {
            let configCalendar = {}
            const todoList = await CONSTANTS.FUNCTION.AXIOS.GET(`${CONSTANTS.URL.TODO_CALENDAR_REMINDER_TRANSPORTATION.GET_ALL_NO_ID}`)

            const providers = await CONSTANTS.FUNCTION.AXIOS.GET(`${CONSTANTS.URL.FACTORY_TRANSPORTATION.GET_ALL}`)

            configCalendar = {
               todoList: todoList.data.data,
               providers: providers.data.data
            }
            const arrayAction = []
            arrayAction.push(
               CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.CALENDAR_MAINTANANCE_CONFIG_TRANSPORTATION.UPDATE_PROVIDERS_TODOLIST, configCalendar)
            )
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

const checkExistedCalendarMaintananceConfig = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.CALENDAR_MAINTANANCE_CONFIG_TRANSPORTATION.CHECK_EXISTED_CALENDAR_MAINTANANCE_CONFIG),
      mergeMap((action) => {
         const api = async () => {
            let transportation = {}
            if (action.payload) {
               const checkExistedCalendar = await CONSTANTS.FUNCTION.AXIOS.GET(
                  `${CONSTANTS.URL.CALENDAR_MAINTANANCE_CONFIG_TRANSPORTATION.CHECK_EXISTED_CALENDAR_MAINTANANCE_CONFIG}?vehicle_id=${action.payload}`
               )

               transportation = { configCalendar: checkExistedCalendar.data.data }
            }
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.UPDATE_CURRENT_TRANSPORTATION, transportation))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

const getCalendarMaintananceConfig = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.CALENDAR_MAINTANANCE_CONFIG_TRANSPORTATION.GET_CALENDAR_MAINTANANCE_CONFIG_TRANSPORTATION),
      mergeMap((action) => {
         const api = async () => {
            let configCalendar = {}
            if (action.payload) {
               const getCalendarMaintananceConfig = await CONSTANTS.FUNCTION.AXIOS.POST(
                  `${CONSTANTS.URL.CALENDAR_MAINTANANCE_CONFIG_TRANSPORTATION.GET_BY_ID}`,
                  {
                     id: action.payload.id,
                     vehicles: JSON.stringify(action.payload.vehicles)
                  }
               )

               configCalendar = {
                  calenderMaintananceConfig: getCalendarMaintananceConfig.data.data
               }
            }
            const arrayAction = []
            arrayAction.push(
               CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.CALENDAR_MAINTANANCE_CONFIG_TRANSPORTATION.UPDATE_PROVIDERS_TODOLIST, configCalendar)
            )
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

const updateCalendarMaintananceConfig = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.CALENDAR_MAINTANANCE_CONFIG_TRANSPORTATION.UPDATE_CALENDAR_MAINTANANCE_CONFIG_TRANSPORTATION),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            // Chuyển cấu trúc json theo yêu cầu backend ở đây
            const updateCalendarConfig = {
               id: action.payload.id,
               kmActive: action.payload.kmActive,
               timeActive: CONSTANTS.FUNCTION.COMMON.formatDate(action.payload.timeActive, "DD/MM/YYYY"),
               username: action.payload.username,
               kmGps: JSON.stringify(action.payload.kmGps),
               vehicles: JSON.stringify(action.payload.vehicles),
               kmMaintanance: JSON.stringify(action.payload.kmMaintanance),
               timeCycle: JSON.stringify(action.payload.timeCycle),
               timeActiveCycle: JSON.stringify(action.payload.timeActiveCycle),
               listItem: JSON.stringify(action.payload.listItem),
               engine_on_timeActive: action.payload.engine_on_timeActive,
               engine_on_timeGps: JSON.stringify(action.payload.engine_on_timeGps)
            }
            const updateCalenderReminder = await CONSTANTS.FUNCTION.AXIOS.POST(
               CONSTANTS.URL.CALENDAR_MAINTANANCE_CONFIG_TRANSPORTATION.POST,
               updateCalendarConfig
            )
            updateCalenderReminder.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, updateCalenderReminder.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, updateCalenderReminder.data.mess))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API gọi km bắt đầu, km kêt thúc
const getKmBeginEnd = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.CALENDAR_MAINTANANCE_CONFIG_TRANSPORTATION.GET_KM_BEGIN_END),
      mergeMap((action) => {
         const api = async () => {
            let getAPI = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.CALENDAR_MAINTANANCE_CONFIG_TRANSPORTATION.GET_KM_BEGIN_END, action.payload)

            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.CALENDAR_MAINTANANCE_CONFIG_TRANSPORTATION.SET_KM_BEGIN_END, getAPI.data.data))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

export default {
   getListForCalendarMaintananceConfig,
   checkExistedCalendarMaintananceConfig,
   getCalendarMaintananceConfig,
   updateCalendarMaintananceConfig,
   getKmBeginEnd
}
